import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useBlog';
import { Button } from '../components/ui/button';
import { Lock, User, AlertCircle } from 'lucide-react';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(username, password);
    
    if (result.success) {
      navigate('/admin/dashboard');
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#F9F6F0] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="bg-white border border-[#D4D1C9] p-8 md:p-12">
          {/* Logo */}
          <div className="text-center mb-8">
            <h1 className="font-heading text-2xl font-semibold text-[#2C4A3E] tracking-tight">
              Fairway<span className="text-[#B89A5A]"> Partners</span>
            </h1>
            <p className="font-body text-sm text-[#6B6860] mt-2">Admin Portal</p>
          </div>

          {/* Error Message */}
          {error && (
            <div className="mb-6 p-4 bg-red-50 border border-red-200 flex items-center gap-3">
              <AlertCircle className="w-5 h-5 text-red-500" />
              <p className="font-body text-sm text-red-600">{error}</p>
            </div>
          )}

          {/* Login Form */}
          <form onSubmit={handleSubmit} data-testid="admin-login-form">
            <div className="mb-6">
              <label className="font-body text-sm text-[#6B6860] block mb-2">Username</label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#6B6860]" />
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  data-testid="admin-username-input"
                  className="w-full border border-[#D4D1C9] bg-transparent px-10 py-3 font-body text-base focus:outline-none focus:border-[#2C4A3E]"
                  placeholder="Enter username"
                  required
                />
              </div>
            </div>

            <div className="mb-8">
              <label className="font-body text-sm text-[#6B6860] block mb-2">Password</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#6B6860]" />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  data-testid="admin-password-input"
                  className="w-full border border-[#D4D1C9] bg-transparent px-10 py-3 font-body text-base focus:outline-none focus:border-[#2C4A3E]"
                  placeholder="Enter password"
                  required
                />
              </div>
            </div>

            <Button
              type="submit"
              data-testid="admin-login-button"
              disabled={loading}
              className="w-full bg-[#2C4A3E] hover:bg-[#2C4A3E]/90 text-white font-body text-base py-4 rounded-none"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </form>

          {/* Back to site */}
          <div className="mt-8 text-center">
            <a href="/" className="font-body text-sm text-[#6B6860] hover:text-[#2C4A3E]">
              ← Back to website
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
